<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <gTop />
    <gHead />
    <gNav />
    <gSite />
    <div class="gContent" :style="{minHeight: (bodyHeight - 256) + 'px'}">
      <div class="chance-detail">
        <div class="main" v-if="chanceMsg">
          <div class="section">
            <div class="title">
              <div style="padding-left:20px;">
                <h2 :title="chanceMsg.subtitle">{{chanceMsg.subtitle}} <em>has released this news</em></h2>
                <span>views：{{chanceMsg.viewCount}}</span>
              </div>
              <div class="title-btn">
                <Button type="info" ghost style="width:70px;height:35px;font-size:14px;margin-right:15px;" :disabled="hasCollect===0?false:true" @click="addCollect">Follow</Button>
                <Button type="error" ghost style="width:200px;height:35px;font-size:14px;" @click="supply">Seek business cooperation</Button>
              </div>
            </div>

            <div>
              <div class="swiper">
                <div class="container">
                  <swiperCommon :imgArr="chanceMsg.photo" v-if="chanceMsg.photo.length"></swiperCommon>
                </div>
              </div>
              <div class="container2">
                <p
                  v-if="chanceMsg.information"
                  v-html="chanceMsg.information ? $service.replaceSpeace(chanceMsg.information) : 'No Data'"
                ></p>
                <p class="more no" v-else>No Data</p>
              </div>
            </div>
          </div>

          <div class="sidebar">
            <sidebarKefu></sidebarKefu>
          </div>
        </div>
        <!-- <erweima :erweimaFlag="erweimaFlag" @closeErweima="erweimaFlag = false" /> -->
      </div>
    </div>
    <supplyModal :show="supplyOpen" @close="supplyOpen=false" :infoData="chanceMsg" :infoType="'供需'"  />
    <gBottom />

    <gLogin :show="show" @close="show=false;" />
  </div>
</template>

<script>
import gLogin from "@components/En/gLogin/gLogin.vue";
import gTop from "@components/En/gTop/gTop.vue";
import swiperCommon from "./swiper-common.vue"; //轮播图
// import leavingmessage from "./leaving-message"; //留言
import sidebarKefu from "./sidebar-kefu"; //边栏 扫描二维码
// import erweimapopup from "@components/erweima-popup"; //遮罩组件
// import erweima from "@components/erweima-popup"; // 点赞二维码
import { mapGetters ,mapActions, mapMutations } from "vuex";
import gHead from "@components/En/gHead/gHead.vue";
import gNav from "@components/En/gNav/gNav.vue";
import gBottom from "@components/En/gBottom/gBottom.vue";
import gSite from "@components/En/gSite/gSite.vue";
import supplyModal from "@components/En/modal/supply-modal"; //供需modal

export default {
  name: "chance-details",
  data() {
    return {
      imgArr: [],
      likeList: [], // 所有点赞人数
      loadState: 1, // 1待加载 2加载中 3全部加载完成
      prodData: [],
      cardData: {},
      TotalPage: 1, // 页总数
      PageIndex: 1, // 当前页
      PageSize: 20, // 当前页
      msgTotal: 0, // 所有留言人数
      codeData: null,
      exData: null,
      erweimaFlag: false, // 点赞二维码弹窗

      chanceMsg:null,
      commentsList:null,
      bodyHeight: "800px",
      hasCollect: 0,
      supplyOpen: false,
      show: false,
    };
  },
  components: {
    gTop,
    gHead,
    gNav,
    gBottom,
    swiperCommon,
    // leavingmessage,
    sidebarKefu,
    gSite,
    supplyModal,
    gLogin,
    // erweimapopup,
    // erweima
  },
  created() {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
    this.init();
  },
  watch: {
    '$route' (to, from) {
      if(to){
        this.init();
      }
    },
    chanceCollectId(val, oldVal) {
      this.isCollect();
    },
    user(val, oldVal) {
      this.isCollect();
    },
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId',
      user: "getUser",
      chanceCollectId: "getChanceCollectId"
    }),
    chanceId(){
      return this.$route.query.chanceId;
    }
  },
  methods: {
    ...mapMutations({
      setChanceCollectId: "setChanceCollectId"
    }),
    ...mapActions({  
      getchanceDetails:'home/getchanceDetails',
      isChanceCollect: "hall/isChanceCollect",
    }),
    async init() {
      this.chanceMsg = await this.getchanceDetails(this.chanceId);
      if (this.chanceMsg) {
        this.isCollect();
      }
      // console.log(this.chanceMsg,'data');
    },
    async isCollect() {
      this.setChanceCollectId("");
      if (!this.user) {
        return;
      }
      let isCollect = await this.isChanceCollect({
        userId: this.user.userId,
        releaseId: this.chanceMsg.id
      });
      this.hasCollect = isCollect;
    },
    addCollect() {
      if (!this.user) {
        this.$Message.warning("请登录后关注");
        this.show = true;
        return;
      }
      const opt = {
        userId: this.user.userId,
        releaseId: this.chanceMsg.id,
      }
      this.$http.post(`/api/ReleaseFollower`, opt, this.$store.state.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                    this.$Message.success("success！");
                    this.isCollect();
                  }else{
                    this.$Message.error("fail,please try again！");
                  }
                })
    },
    supply() {
      if (!this.user) {
        this.$Message.warning("请登录后发布");
        this.show = true;
        return;
      }
      this.supplyOpen = true;
    },
  },
};
</script>

<style scoped lang='scss'>
@import "@/assets/scss/utils.scss";
.home {
  background: #f5f5f5;
}
.gContent {
  background: #f5f5f5;
  width: 1200px;
  margin: 0 auto;
}
.chance-detail{
  padding-bottom: 60px;
}
.top-title {
  height: 50px;
  font-size: 14px;
  line-height: 35px;
  &-link {
    color: #999;
  }
}
.main {
  width: 1200px;
  @include clearfix;

  .section {
    width: 878px;
    box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
    border-radius: 2px;
    background-color: #fff;
    float: left;
    padding-bottom: 40px;

    .title div {
      width: 64%;
      height: 100%;
      float: left;
    }
    .title {
      height: 88px;
      border-bottom: 1px solid #f5f5f5;
      .title-btn {
        width: 36%;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
    }
    .title h2 {
      font-size: 24px;
      color: #222222;
      float: left;
      margin-top: 24px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      width: 85%;
    }
    .title em {
      font-style: normal;
      font-size: 16px;
      color: #666;
      font-weight: 500;
      margin-left: 10px;
      // float: left;
      // margin-top: 28px;
    }
    .title span {
      float: left;
      font-size: 14px;
      color: #999;
      line-height: 1.5em;
      margin-top: 33px;
    }
    .swiper .container {
      width: 100%;
      margin: 25px 0 0 20px;
    }
    .container2 {
      width: 100%;
      margin: 25px 0 0 20px;
    }
    .container2 p {
      font-size: 16px;
      color: #222222;
      line-height: 30px;
      margin-top: 40px;
      text-align: justify;
      word-break: break-all;
    }
    .fabulous {
      height: 130px;
      text-align: center;
      margin-top: 50px;
    }
    .fabulous div {
      display: inline-block;
      width: 220px;
      height: 77px;
      border-radius: 38px;
      border: solid 2px #e6e6e6;
      text-align: center;
      line-height: 77px;
      font-size: 20px;
      color: #222222;
      cursor: pointer;
      span {
        position: relative;
        top: -5px;
      }
      .icon-liuyan4{
        position: relative;
        top: 3px;
      }
    }
    .more {
      height: 80px;
      text-align: center;
    }
    .more span {
      color: #040000;
      font-size: 14px;
      cursor: pointer;
      line-height: 80px;
    }

    .icon {
      width: 1em;
      height: 1em;
      vertical-align: 0em;
      fill: currentColor;
      overflow: hidden;
      margin-right: 5px;
      font-size: 30px;
    }
  }

  .sidebar {
    width: 300px;
    float: right;
  }
}
.pic-content {
  font-size: 0;
  padding:25px; 
  img {
    width: 100%;
  }
}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>